// Debug utility functions that can be shared across components and services

/**
 * Check if debug mode is enabled via URL query parameter
 * @returns {boolean} True if debug mode is enabled
 */
export const isDebugMode = () => {
  if (typeof window !== "undefined") {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("debug") === "true";
  }
  return false;
};

/**
 * Log a message only if debug mode is enabled
 * @param {...any} args - Arguments to pass to console.log
 */
export const debugLog = (...args) => {
  if (isDebugMode()) {
    console.log(...args);
  }
};

/**
 * Log a warning only if debug mode is enabled
 * @param {...any} args - Arguments to pass to console.warn
 */
export const debugWarn = (...args) => {
  if (isDebugMode()) {
    console.warn(...args);
  }
};

/**
 * Log an error only if debug mode is enabled
 * @param {...any} args - Arguments to pass to console.error
 */
export const debugError = (...args) => {
  if (isDebugMode()) {
    console.error(...args);
  }
};
